import { useCallback } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../../api/adminApi";
import type { Category } from "../../../../../api/types/accessTypes";
import type { Investor } from "../../../../../api/types/fundStructureTypes";
import InvestorCommunicationMatrix from "./InvestorCommunicationMatrix";

interface Props {
  investor: Investor;
  categories: Category[];
}

const InvestorCommunicationMatrixTab = ({ categories, investor }: Props) => {
  const fetchInvestorPermissionsResponse = useCallback(() => adminApi.getInvestorPermissions(investor.id), [investor]);
  const getContacts = useCallback(
    async () => adminApi.searchContacts({ fieldIds: [], includeFundInvestors: true, includeInboxData: false }),
    []
  );

  const [investorPermissions, error] = useFetch(fetchInvestorPermissionsResponse);
  const [contacts, contactsLoadError] = useFetch(getContacts);

  if (error || contactsLoadError) {
    logError(error || contactsLoadError, "InvestorDetailsCommunicationMatrixPage");
    return <DataLoadingFailed title="Loading investor permissions" />;
  }

  if (investorPermissions === undefined || contacts === undefined) {
    return <InlineLoader />;
  }

  const { permissions } = investorPermissions;

  return (
    <InvestorCommunicationMatrix
      investor={investor}
      categories={categories}
      permissions={permissions}
      contacts={contacts.items}
    />
  );
};

export default InvestorCommunicationMatrixTab;
